/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Home_TotalInputs */

const en_gc_home_total = /** @type {(inputs: Gc_Home_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total`)
};

const zh_gc_home_total = /** @type {(inputs: Gc_Home_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合计`)
};

/**
* | output |
* | --- |
* | "Total" |
*
* @param {Gc_Home_TotalInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_home_total = /** @type {((inputs?: Gc_Home_TotalInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Home_TotalInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_home_total(inputs)
	return zh_gc_home_total(inputs)
});
export { gc_home_total as "gc.home.total" }